export default __webpack_public_path__ + "static/blob-lhs-7ffa7ab72781c00e3d94a692fd40fde8.png";